// Anasayfadaki tüm metinler burada. Düzenle ve kaydet — sayfa güncellenir.
// Bu dosya saf veri içerir; JSX/asset import yoktur. Asset'ler (ikon vb.) component tarafında map'lenir.

export const site = {
  owner: "Alihan Demirdaş",
  title: "Full Stack Engineer",
  location: "Konya, Türkiye",
  email: "alihandemirdas42@gmail.com",
  phone: "+90 539 828 7206",
  socials: {
    github: "https://github.com/alihandemirdas",
    linkedin: "https://linkedin.com/in/alihandemirdas",
    medium: "https://medium.com/@alihandemirdas",
  },
  mediumRssUrl: "https://alihandemirdas.com.tr/api/medium/articles?limit=3",
  contactPostUrl: "https://alihandemirdas.com.tr/contact",
  brandGradient: ["#ED1944", "#EE8621"],
};

export const nav = {
  links: [
    { label: "Hakkımda", href: "#hakkimda" },
    { label: "Yetkinlikler", href: "#yetkinlikler" },
    { label: "Deneyim", href: "#deneyim" },
    { label: "Projeler", href: "#projeler" },
    { label: "Yazılar", href: "#blog" },
    { label: "İletişim", href: "#iletisim" },
  ],
  themeToggleLabel: "Tema değiştir",
  menuLabel: "Menü",
  backToTopLabel: "Yukarı dön",
};

export const hero = {
  status: "Full Stack Engineer",
  title: { first: "Alihan", last: "DEMİRDAŞ" },
  roles: [
    "Full Stack Engineer",
    "Distributed Systems",
    "AI Orchestration",
    "Mobile Engineer",
    "Backend Engineer",
    "Frontend Engineer",
    "Deep Learning",
  ],
  typewriterSpeed: 70,
  description:
    "Dağıtık sistemler ve AI orkestrasyonu odaklı bir Full Stack Engineer. Web, mobil ve backend tarafında uçtan uca, ölçeklenebilir ürünler geliştirip yayınlıyorum.",
  primaryCta: { label: "Çalışmaları Gör", href: "#projeler" },
  secondaryCta: { label: "İletişime Geç", href: "#iletisim" },
  socials: [
    { label: "GitHub", href: "https://github.com/alihandemirdas" },
    { label: "LinkedIn", href: "https://linkedin.com/in/alihandemirdas" },
    { label: "Medium", href: "https://medium.com/@alihandemirdas" },
    { label: "Mail", href: "mailto:alihandemirdas42@gmail.com" },
  ],
};

export const about = {
  eyebrow: "01 — Hakkımda",
  title: {
    lead: "Full Stack ",
    accent: "Ürünler Geliştiriyorum.",
  },
  paragraphs: [
    "Selam. Ben Alihan. Bazen mikroservisler yazıyorum, bazen uzun süren AI işlerini orkestre ediyorum, bazen de pixel-perfect tasarımları koda dökmek için saatler harcayabiliyorum.",
    "3D Dijital İkiz, multi-agent AI platformları ve mobil uygulamalar (FinansX, PetVitals) gibi projelerde full stack geliştirici oldum. Performans darboğazlarını çözmeyi, sistemler tasarlamayı ve sunucu/veritabanı tarafını optimize etmeyi seviyorum.",
    "Konya'dayım. Necmettin Erbakan Üniversitesi Bilgisayar Mühendisliği'nde lisansımı bitirdim, aynı bölümde yapay zeka ve derin öğrenme üzerine yüksek lisans yapıyorum.",
  ],
  stats: [
    { value: "3+", label: "Mobil uygulama" },
    { value: "5+", label: "Production proje" },
    { value: "+50", label: "FinansX Canlı veri akışı" },
    { value: "24/7", label: "Sürekli geliştirme" },
  ],
  location: "Konya, Türkiye · Yüksek Lisans @NEÜ",
};

export const skills = {
  eyebrow: "02 — Yetkinlikler",
  title: { lead: "Kullandığım ", accent: "Teknolojiler." },
  groups: [
    { label: "Languages", items: ["JavaScript", "TypeScript", "Golang", "Java", "Python", "SQL"] },
    { label: "Backend & Distributed", items: ["Microservices", "Node.js", "Express.js", "FastAPI", "REST", "gRPC"] },
    { label: "Frontend", items: ["React.js", "Next.js", "TailwindCSS", "Redux", "Zustand", "MapLibre GL"] },
    { label: "Mobile", items: ["React Native", "Expo", "Mobile UI/UX"] },
    { label: "Messaging & Real-time", items: ["Apache Kafka", "RabbitMQ", "WebSockets", "Temporal"] },
    { label: "Database & Storage", items: ["PostgreSQL", "Redis", "MongoDB", "MySQL", "Qdrant"] },
    { label: "AI & Computer Vision", items: ["TensorFlow", "Keras", "YOLOv8", "OpenRouter", "RAG Pipelines"] },
    { label: "DevOps & Tools", items: ["Git", "GitHub Actions", "Docker", "Linux", "Coolify", "AWS"] },
  ],
  marquee: [
    "Go", "TypeScript", "React", "Next.js", "React Native", "Temporal.io",
    "PostgreSQL", "Redis", "Qdrant", "Kafka", "FastAPI", "gRPC",
    "MapLibre GL", "Docker", "AWS", "OpenRouter", "RAG", "Keras",
  ],
};

export const eduExp = {
  eyebrow: "03 — Deneyim & Eğitim",
  title: { lead: "Stajdan ", accent: "Production", tail: "'a." },
  experienceHeading: "Profesyonel Deneyim",
  educationHeading: "Eğitim",
  experience: [
    {
      role: "Full Stack Engineer",
      company: "TwinUp — Teklif Bilişim",
      period: "Haziran 2025 — Günümüz",
      points: [
        "withomni.ai multi-agent AI platformu ve CLAVUS 3D Digital Twin projelerinin uçtan uca geliştirilmesinde full stack geliştirici.",
        "Go ve FastAPI ile dağıtık mikroservisler yazarak full-stack mimarilerdeki performans darboğazlarını çözdüm.",
        "Cache ve veritabanı optimizasyonlarıyla büyük ölçekli 3D Dijital İkiz'lerde (React/React Native, MapLibre GL) gerçek zamanlı performans sağladım.",
        "Temporal.io ile multi-LLM RAG pipeline'larını orkastre ederek uzun süren AI iş akışlarında yüksek erişilebilirlik sağladım.",
        "Bulutta ölçeklenebilir, güvenli, sıfır kesintili altyapı deploy ettim.",
      ],
    },
    {
      role: "Software Engineer Intern",
      company: "AkınRobotics — AKINSOFT",
      period: "Şubat 2024 — Haziran 2024",
      points: [
        "Legacy AR-GUI arayüzlerini modern React, TypeScript ve TailwindCSS yığına geçirerek teknik borcu azalttım ve modülariteyi artırdım.",
      ],
    },
    {
      role: "Software Engineer Intern",
      company: "SRL Teknoloji — YTU Teknopark",
      period: "Temmuz 2022 — Eylül 2022",
      points: [
        "6 haftalık stajda Node.js ve Express ile RESTful API endpoint'leri geliştirdim; MongoDB ile veri, Mongoose ile şema tasarımı.",
        "Startup ortamında Git ve GitHub ile versiyon kontrolü ve takım işbirliği deneyimi.",
      ],
    },
  ],
  education: [
    {
      degree: "Yüksek Lisans — Bilgisayar Mühendisliği",
      school: "Necmettin Erbakan Üniversitesi",
      period: "2025 — Günümüz",
      detail: "Yapay zeka ve derin öğrenme",
    },
    {
      degree: "Lisans — Bilgisayar Mühendisliği",
      school: "Necmettin Erbakan Üniversitesi",
      period: "2020 — 2024",
      detail: "Bitirme: Derin öğrenmeyle teknikleriyle bitki hastalıkları tespiti ve ilaç öneri sistemi",
    },
  ],
};

export const portfolio = {
  eyebrow: "04 — Seçilmiş Projeler",
  title: { lead: "Geliştirdiğim ", accent: "Projeler." },
  projects: [
    {
      title: "AI-Powered RAG & Vision Platform",
      url: "https://rag.alihandemirdas.com.tr/",
      desc: "Temporal.io ile workflow orkestrasyonu, OpenRouter API ve Qdrant ile gelişmiş RAG, görsel anlama, dinamik web araması ve güvenli doküman işleme.",
      stack: ["Temporal.io", "Go", "FastAPI", "Qdrant", "OpenRouter"],
    },
    {
      title: "FinansX — Finance & Crypto Tracker",
      url: "https://apps.apple.com/us/app/finansx-g%C3%BCncel-d%C3%B6viz-alt%C4%B1n/id6742147857",
      desc: "50+ varlık ve canlı sohbet odaları için sıfır gecikmeli güncellemeler; yüksek eşzamanlılıkta Node.js backend ve WebSocket altyapısı.",
      stack: ["React Native", "Node.js", "WebSocket", "Socket.io"],
    },
    {
      title: "PetVitals — AI Pet Care Assistant",
      url: "https://apps.apple.com/tr/app/petvitals-ai-pet-care/id6747075653?l=tr",
      desc: "OpenRouter API ile AI evcil hayvan analitiği, RevenueCat abonelik modeli, 10+ dil desteği ile küresel ölçeklenebilir SaaS.",
      stack: ["React Native", "AI/ML", "RevenueCat", "i18n"],
    },
    {
      title: "Deep Learning — Plant Disease Detection",
      url: "#",
      desc: "Bitirme projesi. Derin Öğrenme tabanlı yaprak görüntülerinden bitki hastalıklarının tespiti ve son kullanıcıya sunulması.",
      stack: ["Python", "TensorFlow", "Keras", "YOLOv8"],
    },
  ],
};

export const mobileApps = {
  eyebrow: "05 — Mobil Uygulamalar",
  title: { lead: "App Store & Play Store'da ", accent: "Yayında!" },
  // icon key component tarafında import edilen asset'e map'lenir
  apps: [
    {
      name: "FinansX",
      tagline: "Finance & Crypto Tracker",
      desc: "Canlı döviz, altın ve 50+ kripto para takibi. Socket.io sohbet odaları, WebSocket canlı veri, portföy & cüzdan yönetimi.",
      icon: "finansx",
      appStore: "https://apps.apple.com/us/app/finansx-g%C3%BCncel-d%C3%B6viz-alt%C4%B1n/id6742147857",
      playStore: "https://play.google.com/store/apps/details?id=com.katreo.finansx",
      stack: ["React Native", "Node.js", "Socket.io", "WebSocket"],
    },
    {
      name: "PetVitals",
      tagline: "AI Pet Care Assistant",
      desc: "OpenRouter API ile kişiselleştirilmiş öneri sunan AI destekli evcil hayvan sağlık asistanı. RevenueCat abonelik, 10+ dil.",
      icon: "petvitals",
      appStore: "https://apps.apple.com/tr/app/petvitals-ai-pet-care/id6747075653?l=tr",
      playStore: null,
      stack: ["React Native", "AI/ML", "RevenueCat", "i18n"],
    },
  ],
  appStoreLabel: "App Store",
  googlePlayLabel: "Google Play",
  comingSoonPlayStore: "Yakında Play Store",
};

export const blog = {
  eyebrow: "06 — Yazılar",
  title: { lead: "Medium'da ", accent: "Ben."},
  subtitle: "Yazılım geliştirme, AI ve mühendislik üzerine teknik notlar.",
  loading: "Yükleniyor…",
  readMore: "Devamını oku",
  viewAll: "Tüm yazıları Medium'da gör",
};

export const contact = {
  eyebrow: "07 — İletişim",
  title: { lead: "Bir soru, sorun veya proje mi var? ", accent: "Merhaba de." },
  cards: [
    { kind: "email", label: "E-posta", value: "alihandemirdas42@gmail.com", href: "mailto:alihandemirdas42@gmail.com" },
    { kind: "github", label: "GitHub", value: "github.com/alihandemirdas", href: "https://github.com/alihandemirdas" },
  ],
  form: {
    firstName: { label: "İsim", placeholder: "Ali" },
    lastName: { label: "Soyisim", placeholder: "Demir" },
    email: { label: "E-posta", placeholder: "ben@example.com" },
    message: { label: "Mesaj", placeholder: "Projeni kısaca anlat…" },
    submit: "Mesaj Gönder",
    submitting: "Gönderiliyor…",
    success: "Mesaj gönderildi. Teşekkürler!",
    errorGeneric: "Bir hata oluştu.",
  },
};

export const footer = {
  tagline: "Full Stack Engineer · Konya, TR",
  links: [
    { label: "GitHub", href: "https://github.com/alihandemirdas" },
    { label: "LinkedIn", href: "https://linkedin.com/in/alihandemirdas" },
    { label: "Medium", href: "https://medium.com/@alihandemirdas" },
    { label: "E-posta", href: "mailto:alihandemirdas42@gmail.com" },
  ],
  copyrightHolder: "Alihan Demirdaş",
  copyrightRights: "Tüm hakları saklıdır.",
};
